/**
 * Escapes a user-supplied value for interpolation into a quoted FHIR `_filter` string literal.
 *
 * The `_filter` grammar terminates a string on an unescaped `"`, and treats `\` as the escape
 * character, so a raw term containing either breaks out of the literal: a trailing `\` escapes the
 * closing quote and the parser runs off the end of the expression. Backslashes must be doubled
 * before quotes are escaped, or the backslash added for a quote would itself be doubled.
 */
export const escapeFilterString = (value: string): string => value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
